<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/users" color="error" exact icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 secondary--text headline">{{user.firstName + ' ' + user.lastName}}</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3 pb-2" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex v-if="found" class="text-xs-center" xs12 sm11 md9>
      <v-tabs class="pa-0 ma-0" v-model="manageTab" color="transparent" slider-color="accent" centered>
        <v-tab ripple>Details</v-tab>
        <v-tab ripple>Notes</v-tab>
        <v-tab-item>
          <r-user-details></r-user-details>
        </v-tab-item>
        <v-tab-item>
          Notes component
        </v-tab-item>
      </v-tabs>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
import UserDetails from './UserDetails.vue'
export default {
  components: {
    rCrumbs: Crumbs,
    rUserDetails: UserDetails
  },
  data: () => ({
    found: false,
    manageTab: '0',
    user: {}
  }),
  created () {
    this.beforeEnter()
  },
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      this.user = {...this.$store.getters.userById(this.$route.params.uid)}
    },
    beforeEnter () {
      if (this.$store.getters.userById(this.$route.params.uid)) this.found = true
      else {
        const appMsg = {
          type: 'error',
          msg: 'User not found'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/users')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/ManageUser.vue